import SoftwareProvidersSelect from './software-providers-select';

export default SoftwareProvidersSelect;
